import { render, staticRenderFns } from "./ContentUno.vue?vue&type=template&id=19b0ea0c&scoped=true&"
import script from "./ContentUno.vue?vue&type=script&lang=js&"
export * from "./ContentUno.vue?vue&type=script&lang=js&"
import style0 from "./ContentUno.vue?vue&type=style&index=0&id=19b0ea0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b0ea0c",
  null
  
)

export default component.exports